import script from "./Vendors.vue?vue&type=script&setup=true&lang=js"
export * from "./Vendors.vue?vue&type=script&setup=true&lang=js"

import "./Vendors.vue?vue&type=style&index=0&id=4a2ac72d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2ac72d"]])

export default __exports__